import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(request: Request): Promise<Optional<void>> {
	const url = `${SERVICEBASEURL.BACKEND}/Channel/SetOnMedia`;
	return axios.patch(url, request).toOptionalVoid();
}

export interface Request {
	mediaId: string;
	channelIds: string[];
}
